/**
 * Swiss franc.
 */
export var CHF = {
  code: 'CHF',
  base: 10,
  exponent: 2
};